"use client";

import ErrorMessageClient from "~/components/error-message/ErrorMessageClient";
import { I18nProviderClient } from "~/locales/client";
import { LocaleEnum } from "~/locales/resources";

/**
 * Global error boundary component that catches errors in the app and sends them to Sentry for tracking
 * Error boundaries must be Client Components. This is a limitation of Next.js.
 * @param error - Error object that caused the error boundary to trigger
 * @param reset - Function to reset the error boundary
 */
const GlobalError = ({ reset }: { error: Error; reset: () => void }) => {
  // global-error must include html and body tags
  // Note: We default to 'en' locale since we don't have access to the route params here
  return (
    <html lang="en">
      <body>
        <I18nProviderClient locale={LocaleEnum.EN}>
          <ErrorMessageClient titleKey="error.it-looks-like-something-went-wrong" showRefreshBtn reset={reset} />
        </I18nProviderClient>
      </body>
    </html>
  );
};

export default GlobalError;
